import { z } from 'zod';
import { agentDataSourceRecordSchema } from '../types/agent-data-sources.js';

export namespace GetAgentDataConnectionSources {
  export const paramsSchema = z.object({
    agentId: z.coerce.number(),
  });

  export const querySchema = z.object({
    brandId: z.coerce.number().optional(),
  });

  export const responseSchema = z.object({
    items: z.array(agentDataSourceRecordSchema),
  });

  export type Params = z.infer<typeof paramsSchema>;
  export type Query = z.infer<typeof querySchema>;
  export type Response = z.infer<typeof responseSchema>;
}

export namespace GetAvailableDataConnectionSources {
  export const paramsSchema = z.object({
    agentId: z.coerce.number(),
  });

  export const querySchema = z.object({
    dataConnectionId: z.uuid(),
    brandId: z.coerce.number().optional(),
  });

  export const responseSchema = z.object({
    items: z.array(
      z.object({
        id: z.uuid(),
        name: z.string(),
        sourceIdentifier: z.string(),
        dataConnectionId: z.uuid(),
      })
    ),
  });

  export type Params = z.infer<typeof paramsSchema>;
  export type Query = z.infer<typeof querySchema>;
  export type Response = z.infer<typeof responseSchema>;
}

export namespace AttachDataConnectionSources {
  export const paramsSchema = z.object({
    agentId: z.coerce.number(),
  });

  export const requestBodySchema = z.object({
    dataSourceIds: z.array(z.uuid()).min(1),
    brandId: z.number().nullable().optional(),
  });

  export const responseSchema = z.object({
    success: z.boolean(),
  });

  export type Params = z.infer<typeof paramsSchema>;
  export type RequestBody = z.infer<typeof requestBodySchema>;
  export type Response = z.infer<typeof responseSchema>;
}

export namespace DetachDataConnectionSource {
  export const paramsSchema = z.object({
    agentId: z.coerce.number(),
    dataSourceId: z.uuid(),
  });

  export const querySchema = z.object({
    brandId: z.coerce.number().optional(),
  });

  export const responseSchema = z.object({
    success: z.boolean(),
  });

  export type Params = z.infer<typeof paramsSchema>;
  export type Query = z.infer<typeof querySchema>;
  export type Response = z.infer<typeof responseSchema>;
}

export namespace UpdateDataConnectionSourceEnabled {
  export const paramsSchema = z.object({
    agentId: z.coerce.number(),
    dataSourceId: z.uuid(),
  });

  export const requestBodySchema = z.object({
    isEnabled: z.boolean(),
    brandId: z.number().nullable().optional(),
  });

  export const responseSchema = agentDataSourceRecordSchema;

  export type Params = z.infer<typeof paramsSchema>;
  export type RequestBody = z.infer<typeof requestBodySchema>;
  export type Response = z.infer<typeof responseSchema>;
}
